export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.homecookt.com';

// WebSocket endpoint for real-time order updates.
// The browser derives ws/wss from the page protocol; the host matches the API.
const WS_HOST = API_BASE_URL.replace(/^https?:\/\//, '');
export const ORDER_WS_URL = `${WS_HOST}/ws/orders`;
export const ONLINE_KITCHENS_URL = `${API_BASE_URL}/api/v1/onlinekitchens`;
export const ONLINE_KITCHENS_WITH_FOOD_URL = `${API_BASE_URL}/api/v1/onlinekitchens-with-food`;
export const NEARBY_KITCHENS_URL = `${API_BASE_URL}/api/v1/nearby-kitchens`;

export const CART_ADD_URL = `${API_BASE_URL}/api/v1/cart/add`;
export const CART_VIEW_URL = `${API_BASE_URL}/api/v1/cart`;
export const CART_UPDATE_URL = (cartId: number) => `${API_BASE_URL}/api/v1/cart/${cartId}`;
export const CART_COUNT_URL = `${API_BASE_URL}/api/v1/cart/count`;
export const CART_SUMMARY_URL = (userLat?: number | null, userLon?: number | null, deliveryType: string = 'kitchen_delivery') => {
  const params = new URLSearchParams({ delivery_type: deliveryType });
  if (userLat != null) params.set('user_lat', String(userLat));
  if (userLon != null) params.set('user_lon', String(userLon));
  return `${API_BASE_URL}/api/v1/cart/summary?${params.toString()}`;
};
export const CART_CHECKOUT_URL = `${API_BASE_URL}/api/v1/cart/checkout`;
export const CART_REMOVE_ITEM_URL = (cartId: number) => `${API_BASE_URL}/api/v1/cart/${cartId}`;
export const CART_CLEAR_URL = `${API_BASE_URL}/api/v1/cart`;
export const CART_REORDER_URL = (orderId: number) => `${API_BASE_URL}/api/v1/cart/reorder/${orderId}`;

export const ORDER_CANCEL_URL = (orderId: number) => `${API_BASE_URL}/api/v1/orders/${orderId}/cancel`;
export const ORDER_DELIVERY_OTP_URL = (orderId: number) => `${API_BASE_URL}/api/v1/order/${orderId}/otp`;
export const ORDER_MARK_DELIVERED_URL = (orderId: number) => `${API_BASE_URL}/api/v1/order/${orderId}/mark-delivered`;

export const MY_ORDERS_URL = `${API_BASE_URL}/api/v1/myorders`;
export const ORDER_HISTORY_URL = (page: number, limit: number) => `${API_BASE_URL}/api/v1/order-history?page=${page}&limit=${limit}`;
export const ORDER_DETAILS_URL = (orderId: number) => `${API_BASE_URL}/api/v1/orders/${orderId}`;
export const ORDER_TIMELINE_URL = (orderId: number) => `${API_BASE_URL}/api/v1/orders/${orderId}/timeline`;
export const ORDER_TRACKING_URL = (orderId: number) => `${API_BASE_URL}/api/v1/order-tracking/${orderId}`;

export const MY_KITCHEN_URL = `${API_BASE_URL}/api/v1/my-kitchen`;
export const CREATE_KITCHEN_URL = `${API_BASE_URL}/api/v1/createkitchen`;
export const UPDATE_KITCHEN_URL = (kitchenId: number) => `${API_BASE_URL}/api/v1/updatekitchen/${kitchenId}`;
export const DELETE_KITCHEN_URL = (kitchenId: number) => `${API_BASE_URL}/api/v1/deletekitchen/${kitchenId}`;
export const KITCHEN_STATUS_URL = (kitchenId: number, status: boolean) => `${API_BASE_URL}/api/v1/${kitchenId}/status?status=${status}`;
export const KITCHEN_DASHBOARD_URL = `${API_BASE_URL}/api/v1/kitchen-dashboard`;

export const KITCHEN_ORDERS_URL = `${API_BASE_URL}/api/v1/kitchenorders`;
export const KITCHEN_ORDERS_V2_URL = `${API_BASE_URL}/api/v1/kitchen/orders`;
export const KITCHEN_ORDER_DETAIL_URL = (orderId: number) => `${API_BASE_URL}/api/v1/kitchen/order/${orderId}`;
export const KITCHEN_ORDER_TIMELINE_URL = (orderId: number) => `${API_BASE_URL}/api/v1/kitchen/order/${orderId}/timeline`;
export const KITCHEN_TOGGLE_ACCEPTING_ORDERS_URL = `${API_BASE_URL}/api/v1/kitchen/toggle-accepting-orders`;
export const KITCHEN_ANALYTICS_URL = `${API_BASE_URL}/api/v1/kitchen/analytics`;
export const KITCHEN_BULK_ACTION_URL = `${API_BASE_URL}/api/v1/kitchen/orders/bulk-action`;
export const ORDER_STATUS_URL = (orderId: number) => `${API_BASE_URL}/api/v1/orderstatus/${orderId}`;
export const ORDER_STATUS_UPDATE_URL = (orderId: number) => `${API_BASE_URL}/api/v1/order/${orderId}/orderstatus`;
export const PENDING_DELIVERY_REQUESTS_URL = `${API_BASE_URL}/api/v1/kitchen/pending-delivery-requests`;
export const KITCHEN_DELIVERY_RESPONSE_URL = (orderId: number) => `${API_BASE_URL}/api/v1/order/${orderId}/delivery-response`;
export const DELIVERY_UPDATE_URL = (orderId: number) => `${API_BASE_URL}/api/v1/order/${orderId}/delivery-update`;

export const INVENTORY_URL = `${API_BASE_URL}/api/v1/inventory`;
export const INVENTORY_SUMMARY_URL = `${API_BASE_URL}/api/v1/inventory/summary`;
export const INVENTORY_UPDATE_URL = (foodId: number) => `${API_BASE_URL}/api/v1/inventory/${foodId}`;

export const CREATE_FOOD_URL = `${API_BASE_URL}/api/v1/food`;
export const GET_FOOD_ITEMS_URL = `${API_BASE_URL}/api/v1/get/fooditems`;
export const UPDATE_FOOD_URL = (foodId: number) => `${API_BASE_URL}/api/v1/food/${foodId}`;
export const DELETE_FOOD_URL = (foodId: number) => `${API_BASE_URL}/api/v1/food/${foodId}`;
export const RESTOCK_FOOD_URL = (foodId: number, quantity: number) => `${API_BASE_URL}/api/v1/food/restock/${foodId}?quantity=${quantity}`;
export const TOGGLE_FOOD_STATUS_URL = (foodId: number) => `${API_BASE_URL}/api/v1/food/toggle-status/${foodId}`;
export const FOOD_REVIEW_URL = (foodId: number) => `${API_BASE_URL}/api/v1/food-review/${foodId}`;
export const GET_FOOD_DETAILS_URL = (foodId: number) => `${API_BASE_URL}/api/v1/food/${foodId}`;
export const GET_FOOD_REVIEWS_URL = (foodId: number) => `${API_BASE_URL}/api/v1/food-reviews/${foodId}`;

// Auth endpoints
export const SIGNUP_URL = `${API_BASE_URL}/api/v1/users/signup`;
export const VERIFY_OTP_URL = `${API_BASE_URL}/api/v1/users/verify-otp`;
export const RESEND_OTP_URL = (email: string) => `${API_BASE_URL}/api/v1/users/resend_otp?email=${encodeURIComponent(email)}`;
export const LOGIN_URL = `${API_BASE_URL}/api/v1/users/login`;
export const REFRESH_TOKEN_URL = `${API_BASE_URL}/api/v1/users/refresh-token`;
export const FORGOT_PASSWORD_URL = `${API_BASE_URL}/api/v1/users/forgot-password`;
export const RESET_PASSWORD_URL = `${API_BASE_URL}/api/v1/users/reset-password`;
export const DELETE_USER_URL = `${API_BASE_URL}/api/v1/users/deleteuser`;
export const REGISTER_DEVICE_TOKEN_URL = `${API_BASE_URL}/api/v1/users/register-device-token`;

// Profile endpoints
export const GET_PROFILE_URL = `${API_BASE_URL}/api/v1/users/profile`;
export const UPDATE_PROFILE_URL = `${API_BASE_URL}/api/v1/users/profile`;

// Location endpoints
export const UPDATE_CURRENT_LOCATION_URL = (lat: number, lon: number, address?: string) =>
  `${API_BASE_URL}/api/v1/users/user/location/current?user_lat=${lat}&user_lon=${lon}${address ? `&current_address=${encodeURIComponent(address)}` : ''}`;
export const SAVE_ADDRESS_URL = `${API_BASE_URL}/api/v1/users/user/location/save-address`;
export const GET_SAVED_ADDRESSES_URL = `${API_BASE_URL}/api/v1/users/user/location/addresses`;
export const SET_ACTIVE_ADDRESS_URL = (addressId: string) => `${API_BASE_URL}/api/v1/users/user/location/set-active/${addressId}`;
export const DELETE_ADDRESS_URL = (addressId: string) => `${API_BASE_URL}/api/v1/users/user/location/delete-address/${addressId}`;
export const GET_ACTIVE_LOCATION_URL = `${API_BASE_URL}/api/v1/users/user/location/active`;

export const TOP_RATED_FOODS_URL = (lat?: number | null, lon?: number | null, radius = 15): string => {
  const base = `${API_BASE_URL}/api/v1/top-rated-foods`;
  if (lat != null && lon != null) return `${base}?user_lat=${lat}&user_lon=${lon}&radius=${radius}`;
  return base;
};
export const TRENDING_FOODS_URL = (lat?: number | null, lon?: number | null, radius = 15, limit = 15): string => {
  const base = `${API_BASE_URL}/api/v1/trending-foods`;
  if (lat != null && lon != null) return `${base}?user_lat=${lat}&user_lon=${lon}&radius=${radius}&limit=${limit}`;
  return `${base}?limit=${limit}`;
};
export const RECOMMENDED_FOODS_URL = (lat?: number | null, lon?: number | null, radius = 15, limit = 20): string => {
  const base = `${API_BASE_URL}/api/v1/recommended-foods`;
  if (lat != null && lon != null) return `${base}?user_lat=${lat}&user_lon=${lon}&radius=${radius}&limit=${limit}`;
  return `${base}?limit=${limit}`;
};
export const SEARCH_URL = `${API_BASE_URL}/api/v1/search`;
export const SEARCH_SUGGESTIONS_URL = `${API_BASE_URL}/api/v1/search-suggestions`;

// Notification endpoints
export const NOTIFICATIONS_URL = `${API_BASE_URL}/api/v1/notifications`;
export const NOTIFICATIONS_UNREAD_COUNT_URL = `${API_BASE_URL}/api/v1/notifications/unread-count`;
export const NOTIFICATION_MARK_READ_URL = (id: number) => `${API_BASE_URL}/api/v1/notifications/${id}/read`;
export const NOTIFICATIONS_MARK_ALL_READ_URL = `${API_BASE_URL}/api/v1/notifications/mark-all-read`;
export const NOTIFICATION_DELETE_URL = (id: number) => `${API_BASE_URL}/api/v1/notifications/${id}`;
export const NOTIFICATIONS_DELETE_ALL_URL = `${API_BASE_URL}/api/v1/notifications/delete-all`;
export const NOTIFICATIONS_STREAM_URL = `${API_BASE_URL}/api/v1/notifications/stream`;

// Admin endpoints
export const ADMIN_DASHBOARD_URL = `${API_BASE_URL}/api/v1/admin/dashboard`;
export const ADMIN_USERS_URL = (page: number, limit: number) => `${API_BASE_URL}/api/v1/admin/users?page=${page}&limit=${limit}`;
export const ADMIN_BLOCK_USER_URL = (userId: number) => `${API_BASE_URL}/api/v1/admin/block-user/${userId}`;
export const ADMIN_UNBLOCK_USER_URL = (userId: number) => `${API_BASE_URL}/api/v1/admin/unblock-user/${userId}`;
export const ADMIN_KITCHENS_URL = (page: number, limit: number) => `${API_BASE_URL}/api/v1/admin/kitchens?page=${page}&limit=${limit}`;
export const ADMIN_REVIEW_KITCHEN_URL = (kitchenId: number) => `${API_BASE_URL}/api/v1/admin/review-kitchen/${kitchenId}`;
export const ADMIN_BLOCK_KITCHEN_URL = (kitchenId: number) => `${API_BASE_URL}/api/v1/admin/block-kitchen/${kitchenId}`;
export const ADMIN_UNBLOCK_KITCHEN_URL = (kitchenId: number) => `${API_BASE_URL}/api/v1/admin/unblock-kitchen/${kitchenId}`;
export const ADMIN_PENDING_KITCHENS_URL = (page: number, limit: number) => `${API_BASE_URL}/api/v1/admin/pending-kitchens?page=${page}&limit=${limit}`;
export const ADMIN_FOODS_URL = (page: number, limit: number) => `${API_BASE_URL}/api/v1/admin/foods?page=${page}&limit=${limit}`;
export const ADMIN_REMOVE_FOOD_URL = (foodId: number, reason: string) => `${API_BASE_URL}/api/v1/admin/remove-food/${foodId}?reason=${encodeURIComponent(reason)}`;
export const ADMIN_AUDIT_LOGS_URL = (page: number, limit: number) => `${API_BASE_URL}/api/v1/admin/audit-logs?page=${page}&limit=${limit}`;
export const ADMIN_SEND_PROMOTION_URL = `${API_BASE_URL}/api/v1/admin/send-promotion`;
export const ADMIN_DEBUG_PUSH_URL = `${API_BASE_URL}/api/v1/admin/debug-push`;
